// extracted by mini-css-extract-plugin
export default {"title":"ModalHeader_title__sabvq","action":"ModalHeader_action__X0ZOh"};